// export const carbonFromUnits = units => {
//   const carbons = units*0.5;
//   return cab
// }

import { da } from "date-fns/locale";
import store from "../redux";
import { spendingFunctionCumUnit } from "./cumulativeData";

// export const putPowerInSmartOffSession = (smartOffSessions,loadLogs)=>{
//       let newSmartSessionst =  []
//        for(let session of smartOffSessions){
//           let time = session.start
//           for(let i=0;i<loadLogs.length;i++){
//             if(loadLogs[i].ts>time){
//               if(loadLogs[i-1].p!==0){
//               let obj = {...session,p:loadLogs[i-1]}
//               newSmartSessionst.push(obj)
//               continue
//               }else{
//                 for(let j=i-1;j<0;j--){
//                   if(loadLogs[j].p!==0){

//                   }
//                 }
//               }

//             }
//           }
//        }
// }

//---------------------------------------------------------------------------------------
export const temperatureData = (temperatureLog) => {
  let data = []
  for (let i of temperatureLog) {
    if (i.t > 0) {
      let d = [i.ts, i.t];
      data.push(d);
    }
  }
  return data
}

//---------------------------------------------------------------------------------------
export const currentData = (currentLog) => {
  let data = []
  for (let i of currentLog) {
    if (i.c > 0) {
      let d = [i.ts, i.c];
      data.push(d);
    }
  }
  return data
}

//---------------------------------------------------------------------------------------
export const voltageData = (voltageLog) => {
  let data = []
  for (let i of voltageLog) {
    if (i.c > 0) {
      let d = [i.ts, i.v];
      data.push(d);
    }
  }
  return data
}

//---------------------------------------------------------------------------------------
export const powerConsumption = (loadloag) => {
  let power = []
  for (let i of loadloag) {
    let data = [i.ts, i.p];
    power.push(data);
  }
  return power
}

//-------------------------------------------------------------------
// Define calculation functions
export const calculateGlobalData = (data, housePPU, deviceDetail) => {
  let deviceId = deviceDetail.deviceId
  let globalMoneySpent = 0;
  let globalMoneySaved = 0;
  let globalUnitConsumed = 0;
  let globalNetUnitConsumed = 0;
  let globalNetMoneySpent = 0;
  let globalUnitSaved = 0;
  let globalSaving = 0;
  let globalUnitSavingPercentge = 0;

  let globalCarbonConsumedData = {}
  let globalCarbonSavedData = []
  let globalSavingData = []
  let globalMoneySpentData = []
  let globalMoneySavedData = []
  let globalUnitsConsumedData = []
  let globalUnitsSavedData = []
  let globalOnlineData = []
  let phaseLoadLogs = {};
  let netUnitConsumedData = {};
  let globalNetKwh = 0;
  let globalNetKvah = 0;
  let euValue=0 
  let rowUnitConsumed=0

  data.forEach(data => {
    if (Object.keys(data).length === 0) return;
    const { loadLogs, smartOffSessions } = data;
    let date = new Date(data?.date || Date.now())
      .toLocaleDateString('en-CA');
 
    const sortedLoadLogs = loadLogs !== undefined ? loadLogs.sort((a, b) => parseFloat(a.ts) - parseFloat(b.ts)) : [];
    let phaseCount = deviceId.substring(2, 3)
    let sortAccordingM = phaseCount === "1" ? {
      0: [],
    } : (phaseCount === "2" ? {
      0: [],
      1: [],
    } : {
      0: [],
      1: [],
      2: []
    });
    for (let p of sortedLoadLogs) {
      if (p.m === undefined || p.m === 0) {
        sortAccordingM["0"].push(p);
        if(p.eu!==undefined){
          euValue+=p.eu
        }
      } else {
        if (sortAccordingM[`${p.m}`] === undefined) {
          sortAccordingM[`${p.m}`] = [];
        }
        sortAccordingM[`${p.m}`].push(p);
         if(p.eu!==undefined){
          euValue+=p.eu
        }
      }
    }

    const averageP = averagePower(loadLogs);
    if (netUnitConsumedData[date] === undefined) {
      netUnitConsumedData[date] = {}
    }
    let netUnitData = {}
    if (data?.netUnitLogs !== undefined && data?.netUnitLogs.length > 0) {
      const netUnitLogs = data?.netUnitLogs;
      const sortedNetUnitLogs = netUnitLogs.sort((a, b) => parseFloat(a.ts) - parseFloat(b.ts));
      netUnitData = spendingFunctionCumUnit(sortedNetUnitLogs, deviceDetail?.graphParameters?.cumUnitConsumed?.xAxisInterval, housePPU);
      if (netUnitData) {
        netUnitConsumedData[date] = netUnitData;
        globalNetUnitConsumed += netUnitData?.barGraphData?.totalUnit ?? 0;
        globalNetMoneySpent += netUnitData?.barGraphData?.totalAmount ?? 0;
        globalNetKwh += netUnitData?.totalNetKwh ?? 0;
        globalNetKvah += netUnitData?.totalNetKavh ?? 0;
      }
    } else {
      netUnitConsumedData[date] = {
        data: {},
        unitRate: housePPU,
        totalNetKwh: 0,
        totalNetKavh: 0,
        barGraphData: {
          data: [],
          moneyData: [],
          categories: [],
          totalAmount: 0,
          totalUnit: 0,
        }

      }
    }
    for (let i of Object.keys(sortAccordingM)) {

      const carbonConsumedData = spendingFunction(sortAccordingM[i], deviceId, deviceDetail?.graphParameters?.carbonConsumed?.xAxisInterval, 1, false, deviceDetail?.graphParameters?.saving === undefined ? false : true, deviceDetail?.graphParameters);
      rowUnitConsumed+=carbonConsumedData?.unitConsumed
      let phaseWiseData = {
        name: `${deviceId}-Phase ${Number(i) + 1}`,
        data: carbonConsumedData === undefined || Object.keys(carbonConsumedData).length <= 1
          ? []
          : carbonConsumedData.data,
        categories: carbonConsumedData === undefined || Object.keys(carbonConsumedData).length <= 1
          ? []
          : carbonConsumedData.categories,
        totalSaved: carbonConsumedData === undefined ? 0 : carbonConsumedData.totalSaved,
        totalSavingPer: carbonConsumedData === undefined ? 0 : carbonConsumedData.totalSavingPer,
        totalSavingPerBarData: carbonConsumedData === undefined ? [] : carbonConsumedData.savingPercentageBarData
      }
      if (globalCarbonConsumedData[date] === undefined) {
        globalCarbonConsumedData[date] = []
      }

      globalCarbonConsumedData[date].push(phaseWiseData)
      const totalOffTime = smartOffSessions !== undefined ? smartOffSessions.reduce((total, session) => total + ((session.end - session.start) / 3600000), 0) : 0;

      let unitSaved = averageP * totalOffTime / 1000;
      let unitConsumed = carbonConsumedData?.unitConsumed;
      let moneySaved = unitSaved * housePPU;
      let moneySpent = unitConsumed * housePPU;
      let unitSavingPercentage = unitSaved / (unitConsumed + unitSaved);

      let savingPerNew = (carbonConsumedData?.totalSavingPer || 1) / (unitConsumed + (carbonConsumedData?.totalSavingPer || 0))

      let carbonConsumedSaved = {}
      carbonConsumedSaved = carbonFootprintSaved(
        data.smartOffSessions || [],
        averageP / 1000,
        deviceDetail?.graphParameters?.carbonSaved?.xAxisInterval
      )
      globalCarbonSavedData.push({
        name: `${deviceId}-Phase ${Number(i) + 1}`,
        data: Object.keys(carbonConsumedSaved).length <= 1
          ? []
          : carbonConsumedSaved.data,
        categories: Object.keys(carbonConsumedSaved).length <= 1
          ? []
          : carbonConsumedSaved.categories,
        totalSaved: carbonConsumedData === undefined ? 0 : carbonConsumedSaved.totalSaved,
      });

      globalUnitSaved += isNaN(unitSaved) ? 0 : unitSaved;
      globalUnitConsumed += isNaN(unitConsumed) ? 0 : unitConsumed;
      globalMoneySaved += isNaN(moneySaved) ? 0 : moneySaved;
      globalMoneySpent += isNaN(moneySpent) ? 0 : moneySpent;
      globalUnitSavingPercentge += isNaN(unitSavingPercentage) ? 0 : unitSavingPercentage;
      globalSaving += isNaN(savingPerNew) ? 0 : savingPerNew;

      phaseLoadLogs = {
        ...phaseLoadLogs,
        [`${deviceId}`]: {
          ...phaseLoadLogs[`${deviceId}`],
          [data.date]: {
            ...phaseLoadLogs[`${deviceId}`]?.[data.date],
            [i]: { data: sortAccordingM[i], unit: unitConsumed },
          }
        },
      };
    }

    // Money Saved Bar Chart Data
    let resMoneySaved = moneySavedSmartOffSessions(
      data.smartOffSessions || [],
      averageP,
      housePPU,
      deviceDetail?.graphParameters?.moneySaved?.xAxisInterval
    );

    globalMoneySavedData.push(resMoneySaved)
  });
 
  const systemValues = {
    globalMoneySaved: isNaN(globalMoneySaved) || globalMoneySaved === Infinity ? 0 : globalMoneySaved,
    globalMoneySpent: isNaN(globalMoneySpent) || globalMoneySpent === Infinity ? 0 : globalMoneySpent,
    globalUnitConsumed: isNaN(globalUnitConsumed) || globalUnitConsumed === Infinity ? 0 : globalUnitConsumed,
    globalUnitSaved: isNaN(globalUnitSaved) || globalUnitSaved === Infinity ? 0 : globalUnitSaved,
    globalUnitSavingPercentge: isNaN(globalUnitSavingPercentge) || globalUnitSavingPercentge === Infinity ? 0 : globalUnitSavingPercentge,
    globalSaving: isNaN(globalSaving) || globalSaving === Infinity ? 0 : globalSaving,
    time: calculateTime(data),
    globalNetUnitConsumed: isNaN(globalNetUnitConsumed) || globalNetUnitConsumed === Infinity ? 0 : globalNetUnitConsumed,
    globalNetMoneySpent: isNaN(globalNetMoneySpent) || globalNetMoneySpent === Infinity ? 0 : globalNetMoneySpent,
    globalNetKwh: isNaN(globalNetKwh) || globalNetKwh === Infinity ? 0 : globalNetKwh,
    globalNetKvah: isNaN(globalNetKvah) || globalNetKvah === Infinity ? 0 : globalNetKvah,
  };

  const graphData = {
    carbonConsumed: globalCarbonConsumedData,
    carbonSaved: globalCarbonSavedData,
    unitsConsumed: globalUnitsSavedData,
    unitsSaved: globalUnitsConsumedData,
    moneySaved: globalMoneySavedData,
    moneySpent: globalMoneySpentData,
    online: globalOnlineData,
    netUnitConsumedData: netUnitConsumedData
  }

  const mergePhaseDataofDevice = {}
  for (let deviceId of Object.keys(phaseLoadLogs)) {
    const phaseData = phaseLoadLogs[deviceId]
    mergePhaseDataofDevice[deviceId] = {}

    // Iterate through all dates for this device
    for (let date of Object.keys(phaseData)) {
      const datePhases = phaseData[date]

      // Iterate through all phases for this date
      for (let phaseNum of Object.keys(datePhases)) {
        if (!mergePhaseDataofDevice[deviceId][phaseNum]) {
          mergePhaseDataofDevice[deviceId][phaseNum] = {
            data: [],
            unit: 0
          }
        }
        // Merge data and sum units
        mergePhaseDataofDevice[deviceId][phaseNum].data.push(...datePhases[phaseNum].data)
        mergePhaseDataofDevice[deviceId][phaseNum].unit += isNaN(datePhases[phaseNum].unit) ? 0 : datePhases[phaseNum].unit
      }
    }
  }
  return { systemValues, graphData, phaseLoadLogs: mergePhaseDataofDevice }
};

//----------------------------------------------------------------------------------------
export const calculateGlobalDataa = (data, housePPU) => {

  let globalMoneySpent = 0;
  let globalMoneySaved = 0;
  let globalUnitConsumed = 0;
  let globalUnitSaved = 0;
  let globalUnitSavingPercentge = 0;

  let globalCarbonConsumedData = []
  let globalCarbonSavedData = []
  let globalMoneySpentData = []
  let globalMoneySavedData = []
  let globalUnitsConsumedData = []
  let globalUnitsSavedData = []
  let globalOnlineData = []
  let phaseLoadLogs = {};

  data.forEach(data => {
    let deviceId = data.deviceId

    if (Object.keys(data).length === 0) return;

    const { loadLogs, smartOffSessions } = data;
    const sortedLoadLogs = loadLogs.sort((a, b) => parseFloat(a.ts) - parseFloat(b.ts));

    if (sortedLoadLogs.length === 0) {
      return;
    }
    let sortAccordingM = {
      0: [],
    };
    for (let p of sortedLoadLogs) {
      if (p.m === undefined || p.m === 0) {
        sortAccordingM["0"].push(p);
      } else {
        if (sortAccordingM[`${p.m}`] === undefined) {
          sortAccordingM[`${p.m}`] = [];
        }
        sortAccordingM[`${p.m}`].push(p);
      }
    }
    const averageP = averagePower(loadLogs);



    for (let i of Object.keys(sortAccordingM)) {
      // const averageP = login.userName === user[1].userName ? 2200 : averagePower(loadLogs);

      const carbonConsumedData = spendingFunction(sortAccordingM[i], deviceId, 1,1, false);

      let phaseWiseData = {
        name: `${deviceId}-Phase ${Number(i) + 1}`,
        data: Object.keys(carbonConsumedData).length <= 1
          ? []
          : carbonConsumedData.data,
        categories: Object.keys(carbonConsumedData).length <= 1
          ? []
          : carbonConsumedData.categories,
        totalSaved: carbonConsumedData.totalSaved,
      }
      globalCarbonConsumedData.push(phaseWiseData);



      // const moneySpentData = spendingFunction(sortedLoadLogs, deviceId, deviceDetail?.graphParameters?.moneySpent?.xAxisInterval, housePPU, false);
      // globalMoneySpentData.push(moneySpentData)

      // const unitsConsumedData = spendingFunction(sortedLoadLogs, deviceId, deviceDetail?.graphParameters?.unitsConsumed?.xAxisInterval, 1, false);
      // globalUnitsConsumedData.push(unitsConsumedData)

      // const onlineData = spendingFunction(sortedLoadLogs, deviceId, deviceDetail?.graphParameters?.online?.xAxisInterval, 1, true);
      // globalOnlineData.push(onlineData)

      const totalOffTime = smartOffSessions.reduce((total, session) => total + ((session.end - session.start) / 3600000), 0);

      let unitSaved = averageP * totalOffTime / 1000;
      let unitConsumed = carbonConsumedData?.unitConsumed;
      let moneySaved = unitSaved * housePPU;
      let moneySpent = unitConsumed * housePPU;
      let unitSavingPercentage = unitSaved / (unitConsumed + unitSaved);

      let carbonConsumedSaved = {}
      carbonConsumedSaved = carbonFootprintSaved(
        data.smartOffSessions,
        averageP / 1000,
        1
      )

      globalCarbonSavedData.push({
        name: `${deviceId}-Phase ${Number(i) + 1}`,
        data: Object.keys(carbonConsumedSaved).length <= 1
          ? []
          : carbonConsumedSaved.data,
        categories: Object.keys(carbonConsumedSaved).length <= 1
          ? []
          : carbonConsumedSaved.categories,
        totalSaved: carbonConsumedSaved.totalSaved,
      });

      globalUnitSaved += isNaN(unitSaved) ? 0 : unitSaved;
      globalUnitConsumed += isNaN(unitConsumed) ? 0 : unitConsumed;
      globalMoneySaved += isNaN(moneySaved) ? 0 : moneySaved;
      globalMoneySpent += isNaN(moneySpent) ? 0 : moneySpent;
      globalUnitSavingPercentge += isNaN(unitSavingPercentage) ? 0 : unitSavingPercentage;

      phaseLoadLogs = {
        [deviceId]: {
          ...phaseLoadLogs[deviceId],
          [i]: { data: sortAccordingM[i], unit: unitConsumed },
        },
      };
    }

    // Money Saved Bar Chart Data
    let resMoneySaved = moneySavedSmartOffSessions(
      data.smartOffSessions,
      averageP,
      housePPU,
      1
    );

    globalMoneySavedData.push(resMoneySaved)
  });
  const systemValues = {
    globalMoneySaved: isNaN(globalMoneySaved) || globalMoneySaved === Infinity ? 0 : globalMoneySaved,
    globalMoneySpent: isNaN(globalMoneySpent) || globalMoneySpent === Infinity ? 0 : globalMoneySpent,
    globalUnitConsumed: isNaN(globalUnitConsumed) || globalUnitConsumed === Infinity ? 0 : globalUnitConsumed,
    globalUnitSaved: isNaN(globalUnitSaved) || globalUnitSaved === Infinity ? 0 : globalUnitSaved,
    globalUnitSavingPercentge: isNaN(globalUnitSavingPercentge) || globalUnitSavingPercentge === Infinity ? 0 : globalUnitSavingPercentge,
    time: calculateTime(data)
  };


  const graphData = {
    carbonConsumed: globalCarbonConsumedData,
    carbonSaved: globalCarbonSavedData,
    unitsConsumed: globalUnitsSavedData,
    unitsSaved: globalUnitsConsumedData,
    moneySaved: globalMoneySavedData,
    moneySpent: globalMoneySpentData,
    online: globalOnlineData
  }



  return { systemValues, graphData, phaseLoadLogs }
};

// Newest log timestamp across every selected day and every log type. Reading
// only the first day's stateLogs left this at 0 (shown as 5:30 AM) for meters
// that send load logs but no state logs. 0 still means no log at all.
export const calculateTime = (data) => {
  let time = 0;
  for (const day of data) {
    for (const logs of [day?.stateLogs, day?.loadLogs, day?.netUnitLogs]) {
      for (const log of logs ?? []) {
        const ts = Number(log?.ts);
        if (ts > time) time = ts;
      }
    }
  }
  return time;
};


//---------------------------------------------------------------------------------------
export const moneySavedSmartOffSessions = (smartOffSessions, averageP = 2200, cpu, slotDifference = 1) => {

  if (smartOffSessions.length !== 0) {

    let numSlots = 24 / slotDifference

    let slot = createSlots(slotDifference, numSlots)

    for (let i of smartOffSessions) {
      let obj = { startTime: i.start, endTime: i.end };
      findTimeMoneySavedOffSessions(obj, slot, slotDifference);
    }
    let barData = [];
    let barCategories = [];
    let totalOffTime = 0;
    for (let i of Object.keys(slot)) {
      barData.push((((slot[i].time / 3600000) * averageP) / 1000) * cpu);
      barCategories.push(slot[i].label);
    }

    for (let i of barData) {
      totalOffTime += Number(i);
    }

    let moneySavedData = {
      data: barData,
      categories: barCategories,
      totalSaved: totalOffTime,
    };

    return moneySavedData
  } else {
    return {};
  }
};

const findTimeMoneySavedOffSessions = (time, room, hrs) => {
  let s = new Date(time.startTime).getHours();
  let e = new Date(time.endTime).getHours();

  if (s === e) {
    room[Math.floor(s / hrs)].time += time.endTime - time.startTime;
  } else {
    for (let i = s; i <= e; i++) {
      let slotNumber = Math.floor(i / hrs);
      if (i !== e) {
        if (i === s) {
          let newStart = new Date(time.startTime);
          let endTime = new Date(time.startTime).setHours(i + 1, 0, 0, 0);
          room[slotNumber].time += endTime - newStart;

          // if (!room[slotNumber].devices.includes(id)) {
          //     room[slotNumber].devices.push(id)
          // }
        } else {
          let newStart = new Date(time.startTime).setHours(i, 0, 0, 0);
          let endTime = new Date(time.startTime).setHours(i + 1, 0, 0, 0);
          room[slotNumber].time += endTime - newStart;
          // if (!room[slotNumber].devices.includes(id)) {
          //     room[slotNumber].devices.push(id)
          // }
        }
      }
      if (i === e) {
        let newStart = new Date(time.startTime).setHours(e, 0, 0, 0);
        room[slotNumber].time += time.endTime - newStart;
        // if (!room[slotNumber].devices.includes(id)) {
        //     room[slotNumber].devices.push(id)
        // }
      }
    }
  }
};


//---------------------------------------------------------------------------------------
export const savedVoltageSmartOffSessions = (smartOffSessions) => { };



export const averagePower = (loadLogs) => {
  // Return the maximum value of p from the loadLogs

  if (loadLogs === undefined || loadLogs.length === 0) {
    return 0;
  }
  const maxPower = Math.max(...loadLogs.map(log => log.p));
  return maxPower;
}

//------------------------------------Helper Functions-----------------------------------

function timestampToMinutes(timestamp) {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return hours * 60 + minutes;
}

//---------------------------------------------------------------------------------------
export const createSlots = (slotDifference, numSlots) => {


  if (!Number.isInteger(slotDifference) || slotDifference < 1 || slotDifference > 24) {
    throw new Error("Slot interval must be a whole number between 1 and 24 inclusive.");
  }

  const slots = [];

  for (let i = 0; i < numSlots; i++) {
    const hour = i * slotDifference;
    const ampm = hour < 12 ? "AM" : "PM";
    const label = (hour === 0 ? "12 " : hour > 12 ? hour - 12 : hour) + " " + ampm;

    slots.push({ time: 0, unit: 0, devices: [], label, unit: 0, unitSaved: 0, saving: false, savingUnit: 0 });
  }

  return slots;

  //Sample slot data for understanding
  // let slot = {
  //   0: {
  //     time: 0,
  //     unit: 0,
  //     devices: [],
  //     label: "12 AM",
  //     unitSaved: 0,
  //   },
  //   1: {
  //     time: 0,
  //     unit: 0,
  //     devices: [],
  //     label: "1 AM",
  //     unitSaved: 0,
  //   },
  //   2: {
  //     time: 0,
  //     unit: 0,
  //     devices: [],
  //     label: "2 AM",
  //     unitSaved: 0,
  //   },
}

// const createSlots = (slotDifference, numSlots) => {
//   let slots = [];
//   for (let i = 0; i < numSlots; i++) {
//     const startHour = i * slotDifference;
//     const endHour = (i + 1) * slotDifference;

//     const formatTime = (hour) => {
//       const period = hour < 12 || hour === 24 ? 'AM' : 'PM';
//       const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
//       return `${formattedHour}:00 ${period}`;
//     };

//     slots.push({ 
//       unit: 0, 
//       unitSaved: 0, 
//       time: 0, 
//       label: `${formatTime(startHour)} - ${formatTime(endHour)}`
//     });
//   }
//   return slots;
// };

//---------------------------------------------------------------------------------------
function findTime(time, room, p) {

  const timeDiff = time.endTime - time.startTime;
  const unitConsumed = (p * (timeDiff / (1000 * 60 * 60))) / 1000;
  const unitSaved = ((100 * (timeDiff / (1000 * 60 * 60))) / 1000) - unitConsumed;
  const slotNumber = Math.floor(new Date(time.startTime).getHours());

  if (room[slotNumber].time) {
    room[slotNumber].time += timeDiff;
    room[slotNumber].unit += unitConsumed;
    room[slotNumber].unitSaved += unitSaved;
  }
}

// const calculateUnitConsumedAndSaved = (timeDiff, p) => {
//   const unitConsumed = (p * (timeDiff / (1000 * 60 * 60))) / 1000;
//   const unitSaved = ((100 * (timeDiff / (1000 * 60 * 60))) / 1000) - unitConsumed;
//   return {
//     unitConsumed: isNaN(unitConsumed) ? 0 : unitConsumed,
//     unitSaved: isNaN(unitSaved) ? 0 : unitSaved
//   };
// };

// const findTime = (time, room, p) => {
//   const startTime = new Date(time.startTime);
//   const endTime = new Date(time.endTime);
//   const startHour = startTime.getHours();
//   const endHour = endTime.getHours();

//   for (let i = startHour; i <= endHour; i++) {
//     const slotNumber = Math.floor(i);
//     const newStart = new Date(startTime).setHours(i, 0, 0, 0);
//     const timeDiff = (i === startHour ? Math.min(new Date(newStart).setHours(i + 1, 0, 0, 0), endTime) : Math.min(new Date(newStart).setHours(i + 1, 0, 0, 0), endTime)) - newStart;

//     room[slotNumber].time += timeDiff;

//     const { unitConsumed, unitSaved } = calculateUnitConsumedAndSaved(timeDiff, p);

//     room[slotNumber].unitSaved += unitSaved;
//     room[slotNumber].unit += unitConsumed;
//   }
// };


// 
const updateRoomTimeSlots = (time, room, hrs) => {
  const startHour = new Date(time.startTime).getHours();
  const endHour = new Date(time.endTime).getHours();

  if (startHour === endHour) {
    const slotNumber = Math.floor(startHour / hrs);
    room[slotNumber].time += time.endTime - time.startTime;
  } else {
    for (let i = startHour; i < endHour; i++) {
      const slotNumber = Math.floor(i / hrs);
      const slotStartTime = new Date(time.startTime);
      slotStartTime.setHours(i, 0, 0, 0);
      const slotEndTime = new Date(time.startTime);
      slotEndTime.setHours(i + 1, 0, 0, 0);
      room[slotNumber].time += slotEndTime - slotStartTime;
    }
    const slotNumber = Math.floor(endHour / hrs);
    const lastSlotStartTime = new Date(time.startTime);
    lastSlotStartTime.setHours(endHour, 0, 0, 0);
    room[slotNumber].time += time.endTime - lastSlotStartTime;
  }
};

//----------------------------------------Carbon Consumed------------------------------------------
export const spendingFunction = (log, id, slotDifference = 1, multiplicationFactor = 1, isOnlineGraph, isSavingGraph = false, deviceDetailsGraph) => {

  if (log.length !== 0) {

    let numSlots = 24 / slotDifference // Because there are 24 hrs in a day

    let slot = createSlots(slotDifference, numSlots)

    for (let i = 0; i < log.length; i++) {
        findTimeOfCarbonConsumed(
          { startTime: log[i].ts, endTime: log[i + 1]?.ts },
          slot,
          log[i].p,
          slotDifference,
          log[i].eu
        );
    }
    let total = 0;
    let totalCarbonSaved = 0;
    let totalOntime = 0
    let totalSavingPer = 0

    for (let i = 0; i < numSlots; i++) {
      if (slot[i].unit !== 0) {
        if (slot[i].unit === undefined || isNaN(slot[i].unit)) {
          slot[i].unit = 0;
        }
        total += slot[i].unit;
        if (deviceDetailsGraph !== undefined && deviceDetailsGraph?.saving?.maximumUnitPerHour !== undefined) {
          if (slot[i].saving) {
            totalSavingPer += (deviceDetailsGraph?.saving?.maximumUnitPerHour - (slot[i].unit * multiplicationFactor))
            slot[i].savingUnit = deviceDetailsGraph?.saving?.maximumUnitPerHour - (slot[i].unit * multiplicationFactor)
          }
        }
        totalCarbonSaved += slot[i].unitSaved
        totalOntime += slot[i].time
        slot[i].unit = slot[i].unit * multiplicationFactor;
        slot[i].unitSaved = slot[i].unitSaved * multiplicationFactor;
      }
    }

    let barData = [];
    let barCategories = [];
    let carbonSavedData = [];
    let savingPercentageBarData = []
    for (let i of Object.keys(slot)) {
      barData.push(isOnlineGraph ? slot[i].time / (1000 * 60 * 60) : slot[i].unit);
      carbonSavedData.push(slot[i].unitSaved);
      barCategories.push(slot[i].label);
      savingPercentageBarData.push(slot[i].savingUnit)
    }

    let requiredData = {
      data: barData,
      savingPercentageBarData,
      totalSavingPer,
      categories: barCategories,
      totalSaved: total * multiplicationFactor,
      unitConsumed: total,
      totalOntime: totalOntime / (1000 * 60 * 60),
      carbonSavedData: carbonSavedData,
      totalCarbonSaved: totalCarbonSaved * multiplicationFactor,
    };

    return requiredData
  }
};





const findTimeOfCarbonConsumed = (time, room, p, slotDifference, unitValue) => {

  const startTime = new Date(time.startTime);
  const endTime = new Date(time.endTime);
  const totalDuration = endTime - startTime;

  if (totalDuration <= 0 || time.endTime === undefined) return;

  if (startTime.getHours() === endTime.getHours()) {
    processTimeSlot(startTime, endTime, room, p, slotDifference, unitValue);
  } else {
    for (let i = startTime.getHours(); i <= endTime.getHours(); i++) {
      let segmentStartTime, segmentEndTime;
      if (i === startTime.getHours()) {
        segmentStartTime = startTime;
        segmentEndTime = new Date(startTime).setHours(i + 1, 0, 0, 0);
      } else if (i === endTime.getHours()) {
        segmentStartTime = new Date(startTime).setHours(i, 0, 0, 0);
        segmentEndTime = endTime;
      } else {
        segmentStartTime = new Date(startTime).setHours(i, 0, 0, 0);
        segmentEndTime = new Date(startTime).setHours(i + 1, 0, 0, 0);
      }

      const segmentDuration = segmentEndTime - segmentStartTime;
      if (segmentDuration > 0) {
        const proportionalUnitValue = (unitValue !== undefined && unitValue !== null && unitValue !== "")
          ? (Number(unitValue) * (segmentDuration / totalDuration))
          : unitValue;
        processTimeSlot(segmentStartTime, segmentEndTime, room, p, slotDifference, proportionalUnitValue);
      }
    }
  }
};

const processTimeSlot = (startTime, endTime, room, p, slotDifference, unitValue) => {
  
  const slotStartTime = new Date(startTime);
  const slotEndTime = new Date(endTime);
  const slotNumber = Math.floor(slotStartTime.getHours() / slotDifference);
  const timeDiff = slotEndTime - slotStartTime;

  room[slotNumber].time += timeDiff;

  const { unitConsumed, unitSaved } = calculateUnits(timeDiff, p, unitValue);

  room[slotNumber].unitSaved += unitSaved;
  room[slotNumber].unit += unitConsumed;
  room[slotNumber].saving = true
};

export const calculateUnits = (timeDiff, p, unitValue) => {
  const unitConsumed = unitValue !== undefined && unitValue !== null && unitValue !== "" ? Number(unitValue) : (p * (timeDiff / (1000 * 60 * 60))) / 1000;
  const unitSaved = ((100 * (timeDiff / (1000 * 60 * 60))) / 1000) - unitConsumed;
  return { unitConsumed: isNaN(unitConsumed) ? 0 : unitConsumed, unitSaved: isNaN(unitSaved) ? 0 : unitSaved };
};


//----------------------------------------------Carbon Saved----------------------------------------------------------------
export const carbonFootprintSaved = (smartOffSessions, averageP, slotDifference = 1) => {

  if (smartOffSessions.length !== 0) {
    let total = 0;
    for (let i = 0; i < smartOffSessions.length; i += 1) {
      total += smartOffSessions[i].end - smartOffSessions[i].start;
    }

    let numSlots = 24 / slotDifference // Because there are 24 hrs in a day
    let slots = createSlots(slotDifference, numSlots)// Sample slot data in the function

    for (let i of smartOffSessions) {
      let obj = { startTime: i.start, endTime: i.end };
      findTimeCarbonSaved(obj, slots, slotDifference);
    }
    let barData = [];
    let barCategories = [];
    let totalOffTime = 0;
    for (let i of Object.keys(slots)) {
      barData.push((((slots[i].time / (1000 * 60 * 60)) * averageP)) * 0.83); // Main formula to calculate carbon footprint saved
      barCategories.push(slots[i].label);
    }

    for (let i of barData) {
      totalOffTime += Number(i);
    }

    return {
      data: barData,
      categories: barCategories,
      totalSaved: totalOffTime,
    };
  } else {
    return {};
  }
};

const findTimeCarbonSaved = (time, room, hrs) => {
  let s = new Date(time.startTime).getHours();
  let e = new Date(time.endTime).getHours();

  if (s === e) {
    room[Math.floor(s / hrs)].time += time.endTime - time.startTime;
  } else {
    for (let i = s; i <= e; i++) {
      let slotNumber = Math.floor(i / hrs);
      if (i !== e) {
        if (i === s) {
          let newStart = new Date(time.startTime);
          let endTime = new Date(time.startTime).setHours(i + 1, 0, 0, 0);
          room[slotNumber].time += endTime - newStart;
        } else {
          let newStart = new Date(time.startTime).setHours(i, 0, 0, 0);
          let endTime = new Date(time.startTime).setHours(i + 1, 0, 0, 0);
          room[slotNumber].time += endTime - newStart;
        }
      }
      if (i === e) {
        let newStart = new Date(time.startTime).setHours(e, 0, 0, 0);
        room[slotNumber].time += time.endTime - newStart;
      }
    }
  }
};


export const decimalToBinary = (decimal) => {
  let binary = "";
  while (decimal > 0) {
    binary = (decimal % 2) + binary; // Get the remainder and prepend it to the binary string
    decimal = Math.floor(decimal / 2); // Update the decimal value by dividing by 2
  }
  return binary || "00000"; // Return "0" if input is 0
}
//--------------------------------------------------------------------------------------------------------------------------

